import Classnames from 'classnames';
import './styles.scss';

const Input = ({
  name,
  label,
  tag = 'input',
  type = 'text',
  required = true,
  error = null,
  errorMsg = '',
  ...props
}) => {
  // Create a input dynamically based on Props - variable need to be captalized
  const DynamicTag = tag;

  const inputErrorClass = Classnames({
    inputError: true,
    'inputError--visible': error,
  });

  return (
    <div className="input__wrapper">
      <DynamicTag required={required} type={type} className="input" name={name} {...props} />
      <label className="input__label" htmlFor={name}>
        {label}
      </label>
      <div className={inputErrorClass}>{errorMsg}</div>
    </div>
  );
};

export default Input;
